module.exports = __webpack_public_path__ + "static/media/Steppr loyalty and gifting - Munki Magik.10872663.webp";